import React, { Component } from "react";

export default class Services extends Component {
	constructor() {
      super();
			this.state={

  }
	}
	render() {
		return (
      <div>
        {/* Hero Section */}
        <div className="background-image-fill" style={{backgroundImage: "url('/images/portfolio/garage-1.jpg')"}}>
          <div className="black-background hero row" style={{backgroundColor: "rgba(0,0,0,.7)", minHeight: "450px"}}>
            <div className="center-position">
              <h1 className="white center-position no-margin">Local Garage Door Pros</h1>
              <p className="white subheading centered-text">See what our customers are saying about our service</p>
            </div>
          </div>
        </div>

        {/* Introduction */}
        <div className="large-padding max-width-container centered-text" style={{maxWidth: "1200px"}}>
          <p className="subheading">
            We understand the importance of selecting the specific garage door that will enhance the look of your home. We take the guess work out of the equation on how a particular door will look on your house and impose actual pictures of numerous garage doors on your house prior to installation. Suppling several options on what doors are available to meet your budget are important options that we provide, but viewing exactly how it's going to look on your house is an invaluable insight in helping you choose the right door. Customer satisfaction is our highest priority and we aim to exceed your expectations by providing you with the best brands in the industry.
          </p>
        </div>

        {/* Services Section */}
        <div className="primary-background extra-large-padding white">
          <div className="row">
            {/* Left: INSTALLATION */}
            <div className="small-12 medium-6" style={{padding: "20px"}}>
              <h2 className="white" style={{fontSize: "28px", fontWeight: "bold", marginBottom: "20px"}}>Installation</h2>
              <p className="white" style={{fontSize: "16px", lineHeight: "1.6", fontWeight: "bold", marginBottom: "15px"}}>For residential homes, we install quality garage doors for replacement or new construction.</p>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5", marginBottom: "8px"}}>Remove and haul away existing door, track and hardware</p>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5", marginBottom: "8px"}}>Installation of all new track and hardware with new door</p>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5"}}>Reconnection of previous garage door opener with new secure bracing for the door as applicable</p>
            </div>

            {/* Right: REPAIRS */}
            <div className="small-12 medium-6" style={{padding: "20px"}}>
              <h2 className="white" style={{fontSize: "28px", fontWeight: "bold", marginBottom: "20px"}}>Repairs</h2>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5", marginBottom: "8px"}}>Garage Doors-All Brands</p>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5", marginBottom: "8px"}}>Electric Operator Service</p>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5", marginBottom: "8px"}}>Broken Springs (Overhead or Side mounted)</p>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5", marginBottom: "8px"}}>Automatic Openers</p>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5", marginBottom: "8px"}}>Broken Rollers</p>
              <p className="white" style={{fontSize: "14px", lineHeight: "1.5"}}>Track and Cable Replacements</p>
            </div>
          </div>
        </div>

        {/* Brand Logos */}
        <div className="row large-padding">
          <div className="small-12 medium-3">
            <a target="_blank" href="http://www.wayne-dalton.com/index.html">
              <img style={{width: "100%"}} src="/images/logo-waynedalton.png" alt="wayne dalton" />    
            </a>
          </div>
          <div className="small-12 medium-3">
            <a target="_blank" href="http://www.amarr.com/residential">
              <img style={{width: "100%"}} src="/images/logo-amarr.png" alt="amarr" />     
            </a>
          </div>
          <div className="small-12 medium-3">
            <a target="_blank" href="http://www.liftmaster.com/lmcv2/pages/producttype.aspx?typeid=14">
              <img src="/images/logo-liftmaster.png" alt="liftmaster"/>       
            </a>
          </div>
          <div className="small-12 medium-3">
            <a target="_blank" href="http://www.northwestdoor.com/">
              <img src="/images/logo-northwestdoor.png" alt="northwestdoor" />     
            </a> 
          </div>
        </div>
      </div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/pages/services/index.js